// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loan-details .el-radio__inner:after{background-color:#7100da}.loan-details .radio-with_contnt .el-form-item__content{line-height:normal}.loan-details .radio-with_contnt .el-radio__label{font-size:.75rem}.loan-details .radio-with_contnt .el-radio{margin-right:1rem}.assets-details-error{border:1px solid #f56c6c!important;border-radius:.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
